import { render, staticRenderFns } from "./quotationAdd.vue?vue&type=template&id=60f8a123&scoped=true"
import script from "./quotationAdd.vue?vue&type=script&lang=js"
export * from "./quotationAdd.vue?vue&type=script&lang=js"
import style0 from "./quotationAdd.vue?vue&type=style&index=0&id=60f8a123&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f8a123",
  null
  
)

export default component.exports